import React from "react";

const GetInTouch = () => {
  return (
    <div className="bg-blue-700 text-white p-6  rounded-xl w-full">
      <div className="text-center">
        <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-4">
          Let’s Get in Touch
        </h2>
        <p className="text-sm sm:text-base md:text-lg mb-8 sm:mb-10 md:mb-12">
          Successfully empowered businesses worldwide with cutting-edge
          communication technologies, enhancing operational efficiency and
          scalability.
        </p>

        <div className="flex flex-col sm:flex-row justify-center gap-6 sm:gap-10 lg:gap-16">
          <div className="flex flex-col items-center">
            <img
              src="\assets\icons\phone-icon.svg"
              alt="Email"
              className="w-10 h-10 sm:w-12 sm:h-12 mb-4 rounded-xl"
            />
            <p className="text-sm sm:text-base">EMAIL</p>
            <p className="font-semibold text-sm sm:text-base md:text-lg">
              info@ayanshtechnology.com
            </p>
          </div>
          <div className="flex flex-col items-center">
            <img
              src="\assets\icons\mail-icon.svg"
              alt="Call"
              className="w-10 h-10 sm:w-12 sm:h-12 mb-4 rounded-xl"
            />
            <p className="text-sm sm:text-base">CALL</p>
            <p className="font-semibold text-sm sm:text-base md:text-lg">
              +91-8802319226
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetInTouch;
